(() => {

  const drawer =
    document.getElementById('RRCartDrawer');

  if (!drawer) return;


  const itemsContainer =
    document.getElementById('RRCartItems');

  const cartCount =
    document.getElementById('RRCartCount');

  const subtotal =
    document.getElementById('RRCartSubtotal');

  const savingsRow =
    document.getElementById('RRCartSavingsRow');

  const savingsAmount =
    document.getElementById('RRCartSavings');

  const emptyState =
    document.getElementById('RRCartEmpty');

  const footer =
    document.getElementById('RRCartFooter');

  const upsell =
    document.getElementById('RRCartUpsell');

  const loading =
    document.getElementById('RRCartLoading');


  let isUpdating = false;
  let isAddingProduct = false;


  const productCache =
    new Map();


  /* =========================================================
     MONEY
     ========================================================= */

  function formatMoney(cents) {

    const value =
      Number(cents || 0) / 100;


    return new Intl.NumberFormat(
      'en-AU',
      {
        style: 'currency',
        currency: 'AUD'
      }
    ).format(value);

  }


  /* =========================================================
     ESCAPE HTML
     ========================================================= */

  function escapeHTML(value) {

    if (
      value === null ||
      value === undefined
    ) {

      return '';

    }


    return String(value)

      .replaceAll('&', '&amp;')

      .replaceAll('<', '&lt;')

      .replaceAll('>', '&gt;')

      .replaceAll('"', '&quot;')

      .replaceAll("'", '&#039;');

  }


  /* =========================================================
     PRODUCT JSON
     ========================================================= */

  async function getProductData(handle) {

    if (!handle) return null;


    if (
      productCache.has(handle)
    ) {

      return productCache.get(
        handle
      );

    }


    try {

      const root =
        window.Shopify?.routes?.root ||
        '/';


      const response =
        await fetch(
          `${root}products/${handle}.js`,
          {
            headers: {
              Accept:
                'application/json'
            }
          }
        );


      if (!response.ok) {

        throw new Error(
          'Unable to load product pricing'
        );

      }


      const product =
        await response.json();


      productCache.set(
        handle,
        product
      );


      return product;

    }

    catch (error) {

      console.warn(
        'Rest Right product pricing error:',
        error
      );


      return null;

    }

  }


  /* =========================================================
     COMPARE AT PRICE
     ========================================================= */

  async function getCompareAtPrice(item) {

    const product =
      await getProductData(
        item.handle
      );


    if (
      !product ||
      !Array.isArray(
        product.variants
      )
    ) {

      return 0;

    }


    const variant =
      product.variants.find(
        variant =>
          String(variant.id) ===
          String(item.variant_id)
      );


    if (!variant) {

      return 0;

    }


    return Number(
      variant.compare_at_price ||
      0
    );

  }


  /* =========================================================
     ITEM PRICING
     ========================================================= */

  async function getItemPricing(item) {

    const compareAtPrice =
      await getCompareAtPrice(
        item
      );


    const originalUnitPrice =
      Number(
        item.original_price ||
        item.price ||
        0
      );


    const finalLinePrice =
      Number(
        item.final_line_price ||
        0
      );


    const quantity =
      Math.max(
        1,
        Number(
          item.quantity ||
          1
        )
      );


    const referenceUnitPrice =
      Math.max(
        compareAtPrice,
        originalUnitPrice,
        0
      );


    const referenceLinePrice =
      referenceUnitPrice *
      quantity;


    const shopifyOriginalLine =
      Number(
        item.original_line_price ||
        0
      );


    const displayOriginalLine =
      Math.max(
        referenceLinePrice,
        shopifyOriginalLine,
        finalLinePrice
      );


    const saving =
      Math.max(
        0,
        displayOriginalLine -
        finalLinePrice
      );


    return {

      originalLinePrice:
        displayOriginalLine,

      finalLinePrice,

      saving

    };

  }


  /* =========================================================
     GET CART
     ========================================================= */

  async function getCart() {

    const root =
      window.Shopify?.routes?.root ||
      '/';


    const response =
      await fetch(
        `${root}cart.js`,
        {
          headers: {
            Accept:
              'application/json'
          }
        }
      );


    if (!response.ok) {

      throw new Error(
        'Unable to load cart'
      );

    }


    return response.json();

  }


  /* =========================================================
     OPEN CART
     ========================================================= */

  async function openCart() {

    await refreshCart();


    drawer.classList.add(
      'is-open'
    );


    drawer.setAttribute(
      'aria-hidden',
      'false'
    );


    document.body.classList.add(
      'rr-cart-open'
    );

  }


  /* =========================================================
     CLOSE CART
     ========================================================= */

  function closeCart() {

    drawer.classList.remove(
      'is-open'
    );


    drawer.setAttribute(
      'aria-hidden',
      'true'
    );


    document.body.classList.remove(
      'rr-cart-open'
    );

  }


  window.RROpenCart =
    openCart;

  window.RRCloseCart =
    closeCart;

  window.RRRefreshCart =
    refreshCart;


  /* =========================================================
     ADD PRODUCT FORM TO CART

     This is now the ONLY behaviour we want from
     product page purchase buttons.

     Product form
     ↓
     /cart/add.js
     ↓
     Rest Right drawer
     ========================================================= */

  async function addProductForm(form) {

    if (
      !form ||
      isAddingProduct
    ) {

      return;

    }


    isAddingProduct =
      true;


    try {

      const root =
        window.Shopify?.routes?.root ||
        '/';


      const formData =
        new FormData(form);


      const response =
        await fetch(
          `${root}cart/add.js`,
          {
            method:
              'POST',

            body:
              formData,

            headers: {
              Accept:
                'application/json'
            }
          }
        );


      if (!response.ok) {

        let message =
          'Unable to add product';


        try {

          const errorData =
            await response.json();


          if (
            errorData?.description
          ) {

            message =
              errorData.description;

          }

        }

        catch (error) {

          /* ignore JSON parsing */

        }


        throw new Error(
          message
        );

      }


      await openCart();

    }

    catch (error) {

      console.error(
        'Rest Right Add To Cart:',
        error
      );


      alert(
        error.message ||
        'Something went wrong. Please try again.'
      );

    }

    finally {

      isAddingProduct =
        false;

    }

  }


  /* =========================================================
     INTERCEPT PRODUCT FORM SUBMIT

     THIS FIXES NORMAL ADD TO CART.

     We capture the submit BEFORE Horizon,
     Kaching or older custom redirect code can
     send the browser elsewhere.
     ========================================================= */

  document.addEventListener(
    'submit',

    event => {

      const form =
        event.target;


      if (
        !(form instanceof HTMLFormElement)
      ) {

        return;

      }


      const isProductForm =
        form.matches(
          'form[action*="/cart/add"]'
        ) ||

        form.dataset.type ===
          'add-to-cart-form';


      if (
        !isProductForm
      ) {

        return;

      }


      /*
        Do not interfere with forms inside
        our own cart drawer.
      */

      if (
        form.closest(
          '#RRCartDrawer'
        )
      ) {

        return;

      }


      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();


      addProductForm(
        form
      );

    },

    true
  );


  /* =========================================================
     CUSTOM BUY NOW BUTTON

     Your buy-buttons.liquid contains a separate
     .buy-now-button with its own old checkout redirect.

     Capture the click before that script runs.
     ========================================================= */

  document.addEventListener(
    'click',

    event => {

      const buyNowButton =
        event.target.closest(
          '.buy-now-button'
        );


      if (
        !buyNowButton
      ) {

        return;

      }


      if (
        buyNowButton.closest(
          '#RRCartDrawer'
        )
      ) {

        return;

      }


      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();


      if (
        buyNowButton.disabled ||
        isAddingProduct
      ) {

        return;

      }


      const form =
        buyNowButton.closest(
          'form'
        );


      if (!form) {

        console.warn(
          'Rest Right: Buy Now form not found.'
        );

        return;

      }


      const originalHTML =
        buyNowButton.innerHTML;


      buyNowButton.disabled =
        true;


      buyNowButton.innerHTML =
        '<span>ADDING TO CART...</span>';


      addProductForm(
        form
      ).finally(
        () => {

          buyNowButton.disabled =
            false;


          buyNowButton.innerHTML =
            originalHTML;

        }
      );

    },

    true
  );


  /* =========================================================
     STICKY BUY NOW

     Trigger the main product form rather than
     the old sticky function.
     ========================================================= */

  document.addEventListener(
    'click',

    event => {

      const stickyButton =
        event.target.closest(
          '.sticky-add-to-cart__button'
        );


      if (
        !stickyButton
      ) {

        return;

      }


      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();


      if (
        isAddingProduct
      ) {

        return;

      }


      const section =
        stickyButton.closest(
          '.shopify-section'
        ) ||
        document;


      const form =
        section.querySelector(
          'form[data-type="add-to-cart-form"]'
        ) ||

        section.querySelector(
          'form[action*="/cart/add"]'
        );


      if (
        form
      ) {

        addProductForm(
          form
        );

        return;

      }


      const productDetails =
        section.querySelector(
          '.product-details'
        );


      if (
        productDetails
      ) {

        productDetails.scrollIntoView(
          {
            behavior:
              'smooth',

            block:
              'center'
          }
        );

      }

    },

    true
  );


  /* =========================================================
     REFRESH
     ========================================================= */

  async function refreshCart() {

    try {

      setLoading(
        true
      );


      const cart =
        await getCart();


      await renderCart(
        cart
      );


      updateThemeCartCount(
        cart.item_count
      );


      return cart;

    }

    catch (error) {

      console.error(
        'Rest Right cart error:',
        error
      );

    }

    finally {

      setLoading(
        false
      );

    }

  }


  /* =========================================================
     RENDER
     ========================================================= */

  async function renderCart(cart) {

    cartCount.textContent =
      cart.item_count ||
      0;


    subtotal.textContent =
      formatMoney(
        cart.total_price
      );


    /* EMPTY */

    if (
      !cart.items ||
      !cart.items.length
    ) {

      itemsContainer.innerHTML =
        '';


      emptyState.hidden =
        false;


      footer.style.display =
        'none';


      upsell.style.display =
        'none';


      if (
        savingsRow
      ) {

        savingsRow.hidden =
          true;

      }


      return;

    }


    emptyState.hidden =
      true;


    footer.style.display =
      '';


    upsell.style.display =
      '';


    /* PRICES */

    const pricingData =
      await Promise.all(

        cart.items.map(
          item =>
            getItemPricing(
              item
            )
        )

      );


    /* TOTAL SAVINGS */

    const totalSavings =
      pricingData.reduce(
        (
          total,
          pricing
        ) => {

          return (
            total +
            pricing.saving
          );

        },
        0
      );


    if (
      totalSavings > 0 &&
      savingsRow &&
      savingsAmount
    ) {

      savingsRow.hidden =
        false;


      savingsAmount.textContent =
        `-${formatMoney(
          totalSavings
        )}`;

    }

    else if (
      savingsRow
    ) {

      savingsRow.hidden =
        true;

    }


    /* ITEMS */

    itemsContainer.innerHTML =
      cart.items

        .map(
          (
            item,
            index
          ) => {


            const pricing =
              pricingData[
                index
              ];


            const image =
              item.featured_image?.url ||
              item.image ||
              '';


            const variant =
              item.variant_title &&
              item.variant_title !==
                'Default Title'

                ? item.variant_title

                : '';


            const originalPriceHTML =
              pricing.saving > 0

                ? `
                  <span
                    class="rr-cart__original-price"
                  >
                    ${formatMoney(
                      pricing.originalLinePrice
                    )}
                  </span>
                `

                : '';


            const savingHTML =
              pricing.saving > 0

                ? `
                  <div
                    class="rr-cart__item-saving"
                  >

                    <span
                      class="rr-cart__saving-check"
                    >
                      ✓
                    </span>

                    <span
                      class="rr-cart__saving-label"
                    >
                      YOU SAVE
                    </span>

                    <span
                      class="rr-cart__saving-amount"
                    >
                      ${formatMoney(
                        pricing.saving
                      )}
                    </span>

                  </div>
                `

                : '';


            return `

              <div
                class="rr-cart__item"
                data-rr-line="${
                  index + 1
                }"
              >


                <div
                  class="rr-cart__item-image"
                >

                  ${
                    image

                      ? `
                        <img
                          src="${escapeHTML(
                            image
                          )}"
                          alt="${escapeHTML(
                            item.product_title
                          )}"
                          loading="lazy"
                        >
                      `

                      : ''
                  }

                </div>


                <div
                  class="rr-cart__item-info"
                >


                  <div
                    class="rr-cart__item-title"
                  >

                    ${escapeHTML(
                      item.product_title
                    )}

                  </div>


                  ${
                    variant

                      ? `
                        <div
                          class="rr-cart__variant"
                        >

                          ${escapeHTML(
                            variant
                          )}

                        </div>
                      `

                      : ''
                  }


                  <div
                    class="rr-cart__price-area"
                  >

                    ${originalPriceHTML}


                    <span
                      class="rr-cart__price"
                    >

                      ${formatMoney(
                        pricing.finalLinePrice
                      )}

                    </span>

                  </div>


                  ${savingHTML}


                  <div
                    class="rr-cart__controls"
                  >


                    <div
                      class="rr-cart__quantity"
                    >


                      <button
                        type="button"
                        data-rr-decrease
                        data-line="${
                          index + 1
                        }"
                        aria-label="Decrease quantity"
                      >
                        −
                      </button>


                      <span>
                        ${item.quantity}
                      </span>


                      <button
                        type="button"
                        data-rr-increase
                        data-line="${
                          index + 1
                        }"
                        aria-label="Increase quantity"
                      >
                        +
                      </button>


                    </div>


                    <button
                      type="button"
                      class="rr-cart__remove"
                      data-rr-remove
                      data-line="${
                        index + 1
                      }"
                      aria-label="Remove item"
                    >
                      🗑
                    </button>


                  </div>


                </div>


              </div>

            `;

          }
        )

        .join('');

  }


  /* =========================================================
     CHANGE CART ITEM
     ========================================================= */

  async function changeLine(
    line,
    quantity
  ) {

    if (
      isUpdating
    ) {

      return;

    }


    isUpdating =
      true;


    setLoading(
      true
    );


    try {

      const root =
        window.Shopify?.routes?.root ||
        '/';


      const response =
        await fetch(
          `${root}cart/change.js`,
          {

            method:
              'POST',

            headers: {

              'Content-Type':
                'application/json',

              Accept:
                'application/json'

            },

            body:
              JSON.stringify(
                {
                  line,
                  quantity
                }
              )

          }
        );


      if (
        !response.ok
      ) {

        throw new Error(
          'Unable to update cart'
        );

      }


      const cart =
        await response.json();


      await renderCart(
        cart
      );


      updateThemeCartCount(
        cart.item_count
      );

    }

    catch (error) {

      console.error(
        'Rest Right cart update error:',
        error
      );

    }

    finally {

      isUpdating =
        false;


      setLoading(
        false
      );

    }

  }


  /* =========================================================
     LOADING
     ========================================================= */

  function setLoading(state) {

    if (
      !loading
    ) {

      return;

    }


    loading.hidden =
      !state;

  }


  /* =========================================================
     HORIZON HEADER COUNT
     ========================================================= */

  function updateThemeCartCount(count) {

    const possibleCounts =
      document.querySelectorAll(
        [
          '[data-cart-count]',
          '.cart-count',
          '.cart-count-bubble',
          '[ref="cartBubbleText"]'
        ].join(',')
      );


    possibleCounts.forEach(
      element => {

        const number =
          element.querySelector(
            '[aria-hidden="true"]'
          );


        if (
          number
        ) {

          number.textContent =
            count;

        }

      }
    );


    document.dispatchEvent(

      new CustomEvent(
        'rr:cart-updated',
        {

          detail: {
            itemCount:
              count
          }

        }
      )

    );

  }


  /* =========================================================
     CART DRAWER BUTTONS
     ========================================================= */

  drawer.addEventListener(
    'click',
    event => {


      const closeButton =
        event.target.closest(
          '[data-rr-cart-close]'
        );


      if (
        closeButton
      ) {

        closeCart();

        return;

      }


      const decrease =
        event.target.closest(
          '[data-rr-decrease]'
        );


      if (
        decrease
      ) {

        const line =
          Number(
            decrease.dataset.line
          );


        const item =
          decrease.closest(
            '.rr-cart__item'
          );


        const quantity =
          Number(

            item
              ?.querySelector(
                '.rr-cart__quantity span'
              )
              ?.textContent ||

            1

          );


        changeLine(
          line,
          Math.max(
            quantity - 1,
            0
          )
        );


        return;

      }


      const increase =
        event.target.closest(
          '[data-rr-increase]'
        );


      if (
        increase
      ) {

        const line =
          Number(
            increase.dataset.line
          );


        const item =
          increase.closest(
            '.rr-cart__item'
          );


        const quantity =
          Number(

            item
              ?.querySelector(
                '.rr-cart__quantity span'
              )
              ?.textContent ||

            1

          );


        changeLine(
          line,
          quantity + 1
        );


        return;

      }


      const remove =
        event.target.closest(
          '[data-rr-remove]'
        );


      if (
        remove
      ) {

        const line =
          Number(
            remove.dataset.line
          );


        changeLine(
          line,
          0
        );

      }

    }
  );


  /* =========================================================
     ESCAPE
     ========================================================= */

  document.addEventListener(
    'keydown',
    event => {

      if (
        event.key ===
          'Escape' &&

        drawer.classList.contains(
          'is-open'
        )
      ) {

        closeCart();

      }

    }
  );


  /* =========================================================
     HEADER CART ICON
     ========================================================= */

  document.addEventListener(
    'click',
    event => {

      const cartLink =
        event.target.closest(
          'a[href="/cart"], a[href$="/cart"]'
        );


      if (
        !cartLink
      ) {

        return;

      }


      if (
        cartLink.closest(
          '#RRCartDrawer'
        )
      ) {

        return;

      }


      event.preventDefault();


      openCart();

    }
  );


})();